import React, { ChangeEventHandler, KeyboardEvent, RefObject } from 'react';

interface IInputProps {
  id?: string;
  title?: string;
  placeholder?: string | undefined;
  value?: string | undefined;
  width?: string;
  onKeyDown?: () => void;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  defaultValue?: string;
  inputRef?: RefObject<HTMLInputElement>;
}

const SearchInput: React.FC<IInputProps> = ({
  id,
  title,
  placeholder,
  width,
  value,
  onKeyDown,
  disabled,
  inputRef,
  onChange,
  defaultValue,
}) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onKeyDown?.();
    }
  };

  return (
    <div style={{ width }}>
      <label className="w-full font-bold text-sm" htmlFor="search-input">
        {title}
      </label>
      <input
        id={id}
        ref={inputRef}
        className="w-full border-solid border border-gray-600 rounded p-1 text-sm focus:outline-none"
        type="text"
        disabled={disabled}
        name="search-input"
        defaultValue={defaultValue}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={!disabled ? handleKeyDown : undefined}
        tabIndex={0}
      />
    </div>
  );
};

export default SearchInput;
